import * as J from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { getAspectCorrectedCoordinates as Z } from "../../utilities/uv.js";
import { grain as $ } from "../../helpers/grain.js";
import { distort as oo } from "../../helpers/distort.js";
import { glow as to } from "../../helpers/glow.js";
import { edgeMask as so } from "../../helpers/edgeMask.js";
const ao = {
  name: "Chromatic9",
  collection: "chromatic",
  tags: ["wave", "gradient"],
  props: {
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the wave effect."
    }
  },
  fragmentNode: (i) => {
    const {
      vec3: E,
      vec4: O,
      time: T,
      mix: n,
      sin: l,
      float: o,
      pow: c,
      uv: d,
      color: t
    } = J, _ = t("#efc539"), f = t("#4acd3a"), N = t("#0c4bbf"), u = t("#1f45a6"), C = t("#253b81"), S = t("#2f5c22"), p = 1.7, I = 2, R = 0.05, D = -0.1, G = 0.3, A = 0.6, L = 70, b = 0.9, g = 0.022, Y = 2, F = 0.5, v = 0.15, w = 0.3, x = 2, U = 0.3, B = 0.1, s = d(), { correctedUV: V } = Z(), a = oo(s, G, A, L), W = c(_, o(2.2)), h = c(f, o(2.2)), y = c(N, o(2.2)), k = c(u, o(2.2)), H = n(
      W,
      h,
      s.x
    ), P = n(
      k,
      y,
      s.x
    ), K = n(
      H,
      P,
      s.y
    ), e = a.x.sub(0.5), m = a.y.sub(0.5), M = e.mul(e.mul(m)).add(m.mul(e)).negate(), r = o(1).add(
      o(b).mul(
        l(
          M.add(T.mul(i.speed.uniform).mul(0.02)).div(g)
        )
      )
    ), Q = so({
      inset: p,
      softness: I,
      offsetX: R,
      offsetY: D
    }), X = E(r, r, r).mul(Q).mul(Y), z = n(
      S.mul(B),
      C.mul(U),
      s.y.mul(s.x)
    ), j = $(F)(V), q = O(
      z.add(K.mul(X)).sub(j),
      1
    );
    return to(q, _, v, w, x);
  }
};
export {
  ao as componentDefinition,
  ao as default
};
